// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiSelector_Mxp6a {
  border: 1px solid var( --color-base100 );
  padding-left: 0.35em;
  padding-right: 0.35em;
  padding-bottom: var( --size-padSmall );
  background-color: var( --color-white );
}
.multiSelector_Mxp6a .tag_u5Trq {
  font: normal 15px/24px Inter;
  color: #394756;
  border: 1px solid var( --color-base100 );
  padding: 3px 0.35em;
  overflow: hidden;
  margin-top: 3px;
  white-space: nowrap;
  margin-left: 3px;
  text-overflow: ellipsis;
  border-radius: var( --size-padSmall );
  background-color: var( --color-base050 );
}
.multiSelector_Mxp6a.multiSelector-conditionText_Ow4_M {
  min-width: 250px;
  max-width: 300px;
}
.multiSelector_Mxp6a.multiSelector-comparator_O8W2H {
  min-height: 38px;
}
.multiSelector_Mxp6a.multiSelector-formInput_j1_BQ {
  min-height: 42px;
}
.multiSelector_Mxp6a.multiSelector-formInputNoPad_R8d1d {
  padding: 0px;
}
.multiSelector_Mxp6a.multiSelector-formInputNoPad_R8d1d:hover {
  padding: 0px;
}
.multiSelector_Mxp6a.multiSelector-formInputNoPad_R8d1d:focus-within {
  padding: 0px;
}
.multiSelector_Mxp6a.multiSelector-formInputNoPad_R8d1d:active {
  padding: 0px;
}`, "",{"version":3,"sources":["webpack://./src/theme/MultiSelector.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,qBAAqB;EACrB,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd","sourcesContent":[".multiSelector {\n  border: 1px solid var( --color-base100 );\n  padding-left: 0.35em;\n  padding-right: 0.35em;\n  padding-bottom: var( --size-padSmall );\n  background-color: var( --color-white );\n}\n.multiSelector .tag {\n  font: normal 15px/24px Inter;\n  color: #394756;\n  border: 1px solid var( --color-base100 );\n  padding: 3px 0.35em;\n  overflow: hidden;\n  margin-top: 3px;\n  white-space: nowrap;\n  margin-left: 3px;\n  text-overflow: ellipsis;\n  border-radius: var( --size-padSmall );\n  background-color: var( --color-base050 );\n}\n.multiSelector.multiSelector-conditionText {\n  min-width: 250px;\n  max-width: 300px;\n}\n.multiSelector.multiSelector-comparator {\n  min-height: 38px;\n}\n.multiSelector.multiSelector-formInput {\n  min-height: 42px;\n}\n.multiSelector.multiSelector-formInputNoPad {\n  padding: 0px;\n}\n.multiSelector.multiSelector-formInputNoPad:hover {\n  padding: 0px;\n}\n.multiSelector.multiSelector-formInputNoPad:focus-within {\n  padding: 0px;\n}\n.multiSelector.multiSelector-formInputNoPad:active {\n  padding: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiSelector": `multiSelector_Mxp6a`,
	"tag": `tag_u5Trq`,
	"multiSelector-conditionText": `multiSelector-conditionText_Ow4_M`,
	"multiSelector-comparator": `multiSelector-comparator_O8W2H`,
	"multiSelector-formInput": `multiSelector-formInput_j1_BQ`,
	"multiSelector-formInputNoPad": `multiSelector-formInputNoPad_R8d1d`
};
export default ___CSS_LOADER_EXPORT___;
